import { ATTRS, TAGS } from '../constants';
import { Entity } from '../types';

export class CropVarietyEntity implements Entity {
  public static fromXML(xml: any, matchIDs: any) {
    const attrs = xml._attributes;
    const isoId = attrs[ATTRS.CropVariety.CropVarietyId];
    const id = matchIDs[isoId] ? matchIDs[isoId].id : null;
    return {
      entity: new CropVarietyEntity(id, attrs[ATTRS.CropVariety.CropVarietyDesignator]),
      isoId,
    };
  }
  public type = TAGS.CropVariety;

  constructor(
    public id: string,
    public designator: string
  ) {}

  public toXML(xmlId: string) {
    return {
      _attributes: {
        [ATTRS.CropVariety.CropVarietyId]: xmlId,
        [ATTRS.CropVariety.CropVarietyDesignator]: this.designator,
      },
    };
  }
}
